import { EventEntity } from '../schema/EventEntity';
import { EventsRetentionInfo } from '../types/EventsRetentionInfo';
import { isInAnyOfDateRanges } from '../utils/isInAnyOfDataRanges';

export function evictEventsWithKeys<T extends EventEntity>(
    eventIdsToEvict: string[],
    events: T[],
    eventsRetentionInfo: EventsRetentionInfo
): T[] {
    eventIdsToEvict = [...eventIdsToEvict]; // Copying array so we don't mutate the one being passed in
    const evictedEvents: T[] = [];

    for (let index = events.length - 1; index >= 0 && eventIdsToEvict.length > 0; index--) {
        const currentEvent = events[index];
        const indexOfId = eventIdsToEvict.indexOf(currentEvent.Key);

        if (indexOfId !== -1 && canEventBeEvicted(currentEvent, eventsRetentionInfo)) {
            const removedEvents = events.splice(index, 1);
            evictedEvents.push(...removedEvents);

            eventIdsToEvict.splice(indexOfId, 1);
        } else if (indexOfId !== -1) {
            // As we found the current event in the list of events to evict
            // but its also part of either the date range or events that
            // shouldn't be evicted. Hence this event can't be deleted and
            // we removed the id from the eventIdsToEvict list
            eventIdsToEvict.splice(indexOfId, 1);
        }
    }

    // As we started evicting from end of list so we need to reverse
    // this list so that the events returned are in correct order
    return evictedEvents.reverse();
}

function canEventBeEvicted(eventToEvict: EventEntity, eventsRetentionInfo: EventsRetentionInfo) {
    const { dateRangesToRetain, eventsToRetain } = eventsRetentionInfo;
    return (
        !isInAnyOfDateRanges(eventToEvict, dateRangesToRetain) && !eventsToRetain[eventToEvict.Key]
    );
}
